<template>
  <div class="ed-search-bar">
    <input type="text" :placeholder="placeholder" class="ed-search-bar__input" @keydown.enter="emitFunction">
    <button class="ed-search-bar__addon" @click="emitFunction">
      <slot></slot>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'SearchBar',
    props: {
      placeholder: String,
    },
    methods: {
      emitFunction($event) {
        this.$emit('clickFunction', this.$el.getElementsByClassName('ed-search-bar__input')[0].value, $event)
      },
    },
  };
</script>



// WEBPACK FOOTER //
// searchBar.vue?1e54af83